import React from 'react';
import clsx from 'clsx';

import { SvgActive, SvgInActive } from 'components/SvgIcon';

const UserStatus = ({ status, isLicensed }) => {
  return (
    <div
      className={`m-table-row__svg${clsx({
        ' m-table-row__svg--inactive': !status,
      })}`}
    >
      {status && isLicensed && <SvgActive />}
      {!status && <SvgInActive />}
    </div>
  );
};

export default UserStatus;
